import React, { useEffect, useState } from 'react'
import ApprovalTickets from '../ApprovalTickets/ApprovalTickets'
import "./MyApproval.css"
import SideBar from '../SideBar/SideBar';
import axiosApiInstance from '../axios';
import AllTicketsHeader from '../AllTickets/AllTicketsHeader';

const MyApproval = () => {
    const [searchTerm, setSearchTerm] = useState('');

    const searchHandler = (searchTerm) => {
        setSearchTerm(searchTerm)
    }

    return (
        <>
            <AllTicketsHeader searchKeyword={searchHandler} term={searchTerm} />
            <SideBar />
            <div className="myapproval-view">
                <div className="myapproval-display">
                    <ApprovalTickets term={searchTerm} />
                </div>
            </div>
        </>
    )
}

export default MyApproval
